module.exports = __webpack_public_path__ + "img/51_33.29becfd2.png";